/**
 * Remove undefined values from an object recursively
 * Firestore doesn't accept undefined values
 */
export const cleanObjectForFirestore = (obj) => {
  // Handle null and undefined
  if (obj === null || obj === undefined) {
    return null;
  }

  // Handle Date objects
  if (obj instanceof Date) {
    return obj;
  }

  // Handle Firestore Timestamp objects
  if (obj?.constructor?.name === 'Timestamp' || obj?._seconds !== undefined) {
    return obj;
  }

  // Handle Firestore server timestamps
  if (obj?.constructor?.name === 'ServerTimestampTransform' || obj?._methodName === 'serverTimestamp') {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj
      .filter(item => item !== undefined) // Remove undefined items from arrays
      .map(item => cleanObjectForFirestore(item));
  }

  // Handle objects
  if (typeof obj === 'object') {
    const cleaned = {};
    for (const [key, value] of Object.entries(obj)) {
      // Skip undefined values completely
      if (value === undefined) {
        continue;
      }
      
      // Recursively clean nested values
      const cleanedValue = cleanObjectForFirestore(value);
      
      // Only add the key if the cleaned value is not undefined
      if (cleanedValue !== undefined) {
        cleaned[key] = cleanedValue;
      }
    }
    return cleaned;
  }

  // Return primitive values as-is
  return obj;
};

/**
 * Ensure required fields have default values
 */
export const ensureDefaultValues = (obj, defaults) => {
  const result = { ...obj };
  
  for (const [key, defaultValue] of Object.entries(defaults)) {
    if (result[key] === undefined || result[key] === null) {
      result[key] = defaultValue;
    }
  }
  
  return result;
};